export default __webpack_public_path__ + "static/media/zucchero8.7be7f418.webp";